export const MSG_WARNING = 'warning'
export const MSG_INFO = 'info'

export const MSG_TYPES = [MSG_WARNING, MSG_INFO]
